module.exports = __webpack_public_path__ + "img/no_seal6end.d10aef21.png";